export default "__VITE_ASSET__Bn0vvFGg__"